{
  "name": "gwc-admin",
  "version": "1.7.26",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 4210",
    "start:prod": "ng serve -c production",
    "build": "ng build",
    "deploy": "pnpm build-admin && firebase deploy --only hosting",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "build-admin": "ng build --configuration=production && pnpm sentry:sourcemaps",
    "sentry:sourcemaps": "node ./tools/sentry-release.mjs publish"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/core": "21.2.29",
    "@angular/animations": "^20.3.35",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.35",
    "@angular/compiler": "^20.3.35",
    "@angular/core": "^20.3.35",
    "@angular/forms": "^20.3.35",
    "@angular/material": "^20.2.14",
    "@angular/material-moment-adapter": "^20.2.14",
    "@angular/platform-browser": "^20.3.35",
    "@angular/platform-browser-dynamic": "^20.3.35",
    "@angular/router": "^20.3.35",
    "@fullcalendar/angular": "^6.1.22",
    "@fullcalendar/core": "^6.1.22",
    "@fullcalendar/daygrid": "^6.1.22",
    "@fullcalendar/interaction": "^6.1.22",
    "@fullcalendar/list": "^6.1.22",
    "@fullcalendar/moment": "^6.1.22",
    "@fullcalendar/rrule": "^6.1.22",
    "@fullcalendar/timegrid": "^6.1.22",
    "@ngneat/transloco": "^6.0.0",
    "@sentry/angular": "^8.55.2",
    "@sentry/cli": "^2.58.6",
    "@sentry/types": "^9.47.2",
    "@stripe/stripe-js": "^7.10.0",
    "apexcharts": "^3.45.0",
    "crypto-js": "^4.2.0",
    "highlight.js": "^11.12.0",
    "html2canvas": "^1.4.1",
    "jspdf": "^4.2.1",
    "lodash-es": "^4.18.1",
    "moment": "^2.31.0",
    "ng-apexcharts": "^1.10.0",
    "ngx-clipboard": "^16.0.0",
    "ngx-file-drop": "^16.0.0",
    "ngx-quill": "^24.0.0",
    "ngx-scanner-qrcode": "^1.8.1",
    "papaparse": "^5.7.0",
    "perfect-scrollbar": "^1.5.5",
    "qrcode": "^1.5.4",
    "quill": "^2.0.0",
    "rrule": "^2.8.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.9.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "18.4.3",
    "@angular-eslint/eslint-plugin": "18.4.3",
    "@angular-eslint/eslint-plugin-template": "18.4.3",
    "@angular-eslint/schematics": "18.4.3",
    "@angular-eslint/template-parser": "18.4.3",
    "@angular/build": "^20.3.42",
    "@angular/cli": "^20.3.42",
    "@angular/compiler-cli": "^20.3.35",
    "@angular/language-service": "^20.3.35",
    "@cypress/schematic": "^2.5.0",
    "@sentry/webpack-plugin": "^2.16.0",
    "@tailwindcss/aspect-ratio": "^0.4.2",
    "@tailwindcss/typography": "^0.5.20",
    "@types/chroma-js": "^2.4.0",
    "@types/crypto-js": "^4.2.0",
    "@types/jasmine": "^5.1.0",
    "@types/lodash": "^4.17.27",
    "@types/lodash-es": "^4.17.0",
    "@types/node": "^20.19.43",
    "@typescript-eslint/eslint-plugin": "^7.0.0",
    "@typescript-eslint/parser": "^7.0.0",
    "autoprefixer": "^10.6.2",
    "chroma-js": "^2.4.0",
    "cypress": "^13.0.0",
    "dotenv": "^16.0.0",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-cypress": "^2.15.0",
    "eslint-plugin-import": "^2.29.0",
    "eslint-plugin-jsdoc": "^48.2.3",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "jasmine-core": "^5.1.0",
    "karma": "^6.4.0",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.0",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.3.0",
    "lodash": "^4.18.1",
    "postcss": "^8.5.32",
    "prettier": "^3.9.10",
    "tailwindcss": "^3.4.0",
    "ts-node": "^10.9.0",
    "typescript": "5.8.3",
    "webpack": "^5.112.2"
  }
}
